import React, { Fragment, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom'
import Services from '../../api/Services';
import HeaderTop from '../../components/HeaderTop/HeaderTop'
import Navbar from '../../components/Navbar/Navbar'

import MapSection from '../../components/MapSection/MapSection';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg'
import Footer from '../../components/footer/Footer';

import AirFreight from './AirFreight';
import SeaFreight from './SeaFreight';
import RoadFreight from './RoadFreight';
import WarehouseManagement from './WarehouseManagement';
import CustomsClearance from './CustomsClearance';
import ProjectLogistics from './ProjectLogistics';
import HeavyLifts from './HavyLifts';
import CargoInsurance from './CargoInsurance';
import RemovalsRelocation from './RemovalsRelocation';

const ServiceSinglePage = ({ props }) => {

    const serviceContent = {
        "air-freight": AirFreight,
        "sea-freight": SeaFreight,
        "road-freight": RoadFreight,
        "management": WarehouseManagement,
        "customs-clearance": CustomsClearance,
        "project-logistics": ProjectLogistics,
        "heavy-lifts": HeavyLifts,
        "cargo-insurance": CargoInsurance,
        "removals-relocation": RemovalsRelocation,
    }


    const { slug } = useParams()

    const location = useLocation();
    const serviceDetails = Services.find(item => item.slug === slug)
    const DynamicContent = serviceContent[slug]


    // Scroll to hash section after DynamicContent renders
    useEffect(() => {
        if (location.hash) {
            setTimeout(() => {
                const el = document.querySelector(location.hash);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 100); // small delay to ensure component is mounted
        } else {
            // Scroll to top if no hash
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [location, DynamicContent]);

    return (
        <Fragment>
            <HeaderTop />
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            {DynamicContent && <DynamicContent serviceDetails={serviceDetails} />}
            <MapSection />
            {/* <CtaSection hclass={'wpo-cta-section-s2'} /> */}
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;